import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {BeatLoader} from 'react-spinners';
import moment from  'moment';
import NotificationSystem from 'react-notification-system';
import Modal from 'react-modal';
import Datetime from 'react-datetime';
import {_addNotification, _addNotificationError,getSchoolGrades, groupBy } from "../../../../server/util";
import { get,postWithHeadersResponse,postWithHeaders } from '../../../../server/actions'
import {Pie} from 'react-chartjs-2';
var _ = require('lodash');
var converter = require('number-to-words');
const options={
    responsive: true,
    maintainAspectRatio: false,
  legend: {
    position: 'left',
    labels: {
      boxWidth: 8
    }
  },
  plugins: {
    datalabels: {
       display: true,
       color:'white',
       font: { size: '10',weight: 'bold' },
    }
 }
}
let gradeList=[];
class NegBalChart extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            currentIndex:0,
            schoolYearList:JSON.parse(sessionStorage.getItem('schoolYearsList')),
            chartObj:{
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#CD853F',
                        '#AF6382',
                        '#BC8F8F',
                        '#FFCE55',
                        '#A3A381',
                        '#3672BC',
                        '#FFDEAD',
                        '#FF6380',
                        '#1AAA22',
                        '#FF69B4',
                        '#808080'
                    ],
                    hoverBackgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#CD853F',
                        '#AF6382',
                        '#BC8F8F',
                        '#FFCE55',
                        '#A3A381',
                        '#3672BC',
                        '#FFDEAD',
                        '#FF6380',
                        '#1AAA22',
                        '#FF69B4',
                        '#808080'
                    ]
                }]
            }
        }
        this.initCurrentIndex=this.initCurrentIndex.bind(this)
        this.onChangeSchoolYear=this.onChangeSchoolYear.bind(this);
        this.getData=this.getData.bind(this);
    }
    componentWillMount=()=>{
        this.initCurrentIndex();
    }
    componentWillReceiveProps=(nextProps)=> {
        if(this.props.schoolYear!=''){ 
            this.setState({schoolYearList:JSON.parse(sessionStorage.getItem('schoolYearsList'))},()=>{
                this.initCurrentIndex(); 
            })
        }
    }
    initCurrentIndex=()=>{
        let stateObj=this.state;
       let index= _.findIndex(stateObj.schoolYearList, function(sYear) { return sYear.schoolYear == sessionStorage.getItem('schoolYearValue') });
       this.setState({currentIndex:index},()=>{
        this.onChangeSchoolYear();
    })
    }
    onChangeSchoolYear=()=>{        
        this.getData()

    }
    getData=()=>{ 
        let currentSession=this.state.currentIndex==-1?undefined:this.state.schoolYearList[this.state.currentIndex];
        if(currentSession!=undefined){
            let schoolYear=currentSession.schoolYear;           
        get('/dashboard/negativeBalanceStudents?mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&schoolYear=' + schoolYear + '&access_token=').then((response) => {
            this.setState({loading: true})
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(respData => {
            console.log('data', respData);
            let orders = respData || {};
            let _chartObj=this.state.chartObj;
            _chartObj.labels=[];
            _chartObj.datasets[0].data=[];
            const gradeGroup=groupBy(gradeList,'value');
            Object.keys(orders).map((key)=>{
                const label=((gradeGroup[key]||[])[0]||{}).label;
                _chartObj.labels.push(label)
                _chartObj.datasets[0].data.push(orders[key])
            })
            this.setState({ lineChart:_chartObj,loading: false })            
        }).catch(
            (error) => {
                this.setState({loading: false})
                console.log('Get School data response', error)
            }
        );
        }
    }
    render(){
        gradeList=getSchoolGrades(0,false); 
        let schoolSessionYear= this.state.schoolYearList==null?'':
        (this.state.schoolYearList[this.state.currentIndex==-1?0: this.state.currentIndex].name)
        return(<div>
         <NotificationSystem ref="notificationSystem"/>
         <div className="col-md-4"> 
         <div className='sweet-loading'
                     style={{position: 'absolute', top: '50%', left: '48%', zIndex: '1000'}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>          
         <div className="panel chart-panel">
            <div className="panel-heading text-center" style={{padding:'0px'}}>
                <span className="panel-title" 
                style={{fontSize: '14px', fontWeight:'600'}}>
                 {'Negative Balance Students' }</span>
                <div className="pull-right">
                {
                    this.state.currentIndex>0?<a href='javascript:void(0)'  className="btn-lt" onClick={()=>{
                        let cIndex=this.state.currentIndex;
                        cIndex=(cIndex-1)<0?0:(cIndex-1);
                        this.setState({currentIndex:cIndex},()=>{
                            this.onChangeSchoolYear();
                        })
                    }}><i className='fa fa-chevron-circle-left '></i></a>: <a className="btn-lt" disabled="disabled"><i className='fa fa-chevron-circle-left '></i></a>
                }
                {
                    this.state.currentIndex<(this.state.schoolYearList==null?[]:this.state.schoolYearList).length-1?<a href='javascript:void(0)' className="btn-gt" onClick={()=>{
                        let cIndex=this.state.currentIndex;
                        cIndex=(cIndex+1)>this.state.schoolYearList.length-1?this.state.schoolYearList.length-1:(cIndex+1);
                        this.setState({currentIndex:cIndex},()=>{
                            this.onChangeSchoolYear();
                        })
                    }} ><i className='fa fa-chevron-circle-right'></i></a>:<a className="btn-gt" disabled="disabled"><i className='fa fa-chevron-circle-right'></i></a>
                }   
                </div>
                <p className="panel-title" 
                style={{fontSize: '12px', fontWeight:'600'}}>
                 {'[School Year: '+schoolSessionYear +']' }</p>
            </div>
            <div className="panel-body" style={{padding:'0px'}}>        
            <Pie data={this.state.chartObj} options={options} onElementsClick={elems => {
                     if(elems.length>0){
                        let currentSession=this.state.currentIndex==-1?undefined:this.state.schoolYearList[this.state.currentIndex];
                            if(currentSession!=undefined){
                                const gradeGroup=groupBy(gradeList,'label');
                                let schoolYear=currentSession.schoolYear;
                                console.log(elems[0]._datasetIndex + ', ' + elems[0]._index);                                
                                const gradeValue=((gradeGroup[elems[0]._model.label]||[])[0]||{}).value;                              
                                let action='negativeBal';
                                this.props.onElementClick(gradeValue,action,schoolYear)
                            }
                        
                     }                    
                }} />
            </div>
            </div>
        </div>
        </div>)
    }
}
export default NegBalChart


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/DashboardCharts/NegBalChart.jsx